import { render, staticRenderFns } from "./modal-resultado.vue?vue&type=template&id=1f083f6c&scoped=true&"
import script from "./modal-resultado.vue?vue&type=script&lang=js&"
export * from "./modal-resultado.vue?vue&type=script&lang=js&"
import style0 from "./modal-resultado.vue?vue&type=style&index=0&id=1f083f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f083f6c",
  null
  
)

export default component.exports